// import local from "./local";
// import dev from "./dev";
// import staging from "./staging";
import prod from "./prod";

var config = prod; // update here, change the config based on the phase of development.

export default Object.freeze({
  login_url: config.login_url,
  pnl_url: config.pnl_url,
  hostname: config.hostname,
});
